import React from "react";
import { createRoot } from "react-dom/client";
import "./styles/index.scss";
import { BrowserRouter } from "react-router-dom";
import { PersistGate } from "redux-persist/lib/integration/react";
import { Provider } from "react-redux";
import App from "./App";
import { store } from "./redux";
import "./index.css";
// const state = useSelector(state => state.userInfo())

import persistStore from "redux-persist/es/persistStore";

let persistor = persistStore(store);

const root = createRoot(document.getElementById("root"));
//
root.render(
    <Provider store={store}>
        <PersistGate persistor={persistor}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </PersistGate>
    </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
